<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { apiBaseUrl } from './runtime-config.mjs'
import {
  browserSessionIdFromQuery,
  cancelBrowserSession,
  startBrowserSessionHeartbeat
} from './browser-session.mjs'

export default {
  name: 'App',
  data() {
    return {
      browserSession: '',
      stopBrowserSessionHeartbeat: null,
      stopRouteWatch: null
    }
  },
  mounted() {
    this.stopRouteWatch = this.$watch(
      () => this.$route.query.browser_session,
      () => this.syncBrowserSession(),
      { immediate: true }
    )
    window.addEventListener('pagehide', this.cancelPendingBrowserSession)
  },
  beforeUnmount() {
    this.stopRouteWatch?.()
    this.stopBrowserSessionHeartbeat?.()
    window.removeEventListener('pagehide', this.cancelPendingBrowserSession)
  },
  methods: {
    syncBrowserSession() {
      const nextSession = browserSessionIdFromQuery(this.$route.query)
      if (nextSession === this.browserSession) return
      this.stopBrowserSessionHeartbeat?.()
      this.browserSession = nextSession
      this.stopBrowserSessionHeartbeat = startBrowserSessionHeartbeat({
        apiBaseUrl: apiBaseUrl(window.location),
        browserSession: nextSession
      })
    },
    cancelPendingBrowserSession() {
      cancelBrowserSession({
        apiBaseUrl: apiBaseUrl(window.location),
        browserSession: this.browserSession
      })
    }
  }
}
</script>

<style>
/* Global styles are imported in main.js */
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
